import { defineAsyncComponent } from 'vue'

const Tsl = defineAsyncComponent(() => import('./tsl.vue'))
const TslModal = defineAsyncComponent(() => import('./tsl-modal.vue'))
const TslsSelect = defineAsyncComponent(() => import('./tsls-select.vue'))
const TslsTable = defineAsyncComponent(() => import('./tsls-table.vue'))

export { Tsl, TslModal, TslsSelect, TslsTable }
